{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} और {{ moreCount }} और",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} और {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} फ़ाइल",
  "{{ count }} files_other": "{{ count }} फ़ाइलें",
  "{{ count }} members_one": "{{ count }} सदस्य",
  "{{ count }} members_other": "{{ count }} सदस्य",
  "{{ count }} members added_one": "{{ count }} सदस्य जोड़ा गया",
  "{{ count }} members added_other": "{{ count }} सदस्य जोड़े गए",
  "{{ count }} people are typing_one": "{{ count }} व्यक्ति टाइप कर रहा है",
  "{{ count }} people are typing_many": "{{ count }} लोग टाइप कर रहे हैं",
  "{{ count }} people are typing_other": "{{ count }} लोग टाइप कर रहे हैं",
  "{{ count }} photos_one": "{{ count }} फ़ोटो",
  "{{ count }} photos_other": "{{ count }} फ़ोटो",
  "{{ count }} reactions_one": "{{ count }} प्रतिक्रिया",
  "{{ count }} reactions_other": "{{ count }} प्रतिक्रियाएं",
  "{{ count }} videos_one": "{{ count }} वीडियो",
  "{{ count }} videos_other": "{{ count }} वीडियो",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} और {{ secondUser }}",
  "{{ imageCount }} more": "{{ imageCount }} और",
  "{{ member }} will be able to message you again.": "{{ member }} आपको फिर से संदेश भेज सकेगा।",
  "{{ member }} won't be able to message you anymore.": "{{ member }} अब आपको संदेश नहीं भेज सकेगा।",
  "{{ memberCount }} members": "{{ memberCount }} मेंबर्स",
  "{{ typing }} are typing": "{{ typing }} टाइप कर रहे हैं",
  "{{ typing }} is typing": "{{ typing }} टाइप कर रहा है",
  "{{ user }} has been muted": "{{ user }} को म्यूट कर दिया गया है",
  "{{ user }} has been unmuted": "{{ user }} को अनम्यूट कर दिया गया है",
  "{{ user }} is typing...": "{{ user }} टाइप कर रहा है...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} और {{ user }} टाइप कर रहे हैं...",
  "{{ users }} and more are typing...": "{{ users }} और अधिक टाइप कर रहे हैं...",
  "{{ watcherCount }} online": "{{ watcherCount }} ऑनलाइन",
  "{{count}} new messages_one": "{{count}} नया संदेश",
  "{{count}} new messages_other": "{{count}} नए संदेश",
  "{{count}} unread_one": "{{count}} अपठित",
  "{{count}} unread_other": "{{count}} अपठित",
  "{{count}} votes_one": "{{count}} वोट",
  "{{count}} votes_other": "{{count}} वोट",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+{{count}} और विकल्प",
  "+{{count}} more options_other": "+{{count}} और विकल्प",
  "🏙 Attachment...": "🏙 अटैचमेंट",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} ने बनाया: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} ने वोट दिया: {{pollOptionText}}",
  "📍Shared location": "📍साझा किया गया स्थान",
  "Actions": "Actions",
  "Add": "जोड़ें",
  "Add {{ count }} members_one": "{{ count }} सदस्य जोड़ें",
  "Add {{ count }} members_other": "{{ count }} सदस्य जोड़ें",
  "Add a comment": "एक टिप्पणी जोड़ें",
  "Add a comment to your poll answer": "अपने पोल उत्तर में एक टिप्पणी जोड़ें",
  "Add an option": "एक विकल्प जोड़ें",
  "Add channel members": "चैनल सदस्य जोड़ें",
  "Add members": "सदस्य जोड़ें",
  "Add reaction": "प्रतिक्रिया जोड़ें",
  "Admin": "एडमिन",
  "All results loaded": "सभी परिणाम लोड हो गए",
  "Allow access to camera": "कैमरा तक पहुँच दें",
  "Allow access to microphone": "माइक्रोफ़ोन तक पहुँच दें",
  "Allow comments": "टिप्पणियाँ की अनुमति दें",
  "Allow option suggestion": "विकल्प सुझाव की अनुमति दें",
  "Allow others to add comments": "दूसरों को टिप्पणी जोड़ने दें",
  "Already a member": "पहले से सदस्य",
  "Also send as a direct message": "सीधे संदेश के रूप में भी भेजें",
  "Also send in channel": "चैनल में भी भेजें",
  "Also sent in channel": "चैनल में भी भेजा गया",
  "An error has occurred during recording": "रेकॉर्डिंग के दौरान एक त्रुटि आ गई है",
  "An error has occurred during the recording processing": "रेकॉर्डिंग प्रोसेसिंग के दौरान एक त्रुटि आ गई है",
  "Anonymous": "गुमनाम",
  "Anonymous poll": "गुमनाम मतदान",
  "Archive": "आर्काइव",
  "Are you sure you want to delete this message?": "क्या आप वाकई इस संदेश को हटाना चाहते हैं?",
  "Are you sure you want to leave this channel?": "Are you sure you want to leave this channel?",
  "aria/Attachment": "अनुलग्नक",
  "aria/Attachment Actions": "अटैचमेंट क्रियाएँ",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "ऑडियो स्थिति {{ elapsed }} / {{ duration }}",
  "aria/Audio position {{ progress }} percent": "ऑडियो स्थिति {{ progress }} प्रतिशत",
  "aria/Block User": "उपयोगकर्ता को ब्लॉक करें",
  "aria/Bookmark Message": "संदेश बुकमार्क करें",
  "aria/Cancel recording": "रिकॉर्डिंग रद्द करें",
  "aria/Cancel Reply": "उत्तर रद्द करें",
  "aria/Cancel upload": "अपलोड रद्द करें",
  "aria/Channel Actions": "चैनल क्रियाएँ",
  "aria/Channel details": "चैनल विवरण",
  "aria/Channel list": "चैनल सूची",
  "aria/Channel search results": "चैनल खोज परिणाम",
  "aria/Chat view tabs": "चैट व्यू टैब",
  "aria/Clear search": "खोज साफ़ करें",
  "aria/Close callout dialog": "कॉलआउट संवाद बंद करें",
  "aria/Close thread": "थ्रेड बंद करें",
  "aria/Collapse sidebar": "साइडबार संक्षिप्त करें",
  "aria/Command Suggestions": "कमांड सुझाव",
  "aria/Complete recording": "रिकॉर्डिंग पूर्ण करें",
  "aria/Copy Message Text": "संदेश की टेक्स्ट कॉपी करें",
  "aria/Decrease value": "मान घटाएं",
  "aria/Delete Message": "संदेश डिलीट करें",
  "aria/Dismiss notification": "सूचना बंद करें",
  "aria/Download attachment": "अनुलग्नक डाउनलोड करें",
  "aria/Edit Message": "मैसेज में बदलाव करे",
  "aria/Emoji picker": "इमोजी चुनने वाला",
  "aria/Emoji Suggestions": "इमोजी सुझाव",
  "aria/Exit search": "खोज से बाहर निकलें",
  "aria/Expand sidebar": "साइडबार विस्तारित करें",
  "aria/File input": "फ़ाइल इनपुट",
  "aria/File upload": "फ़ाइल अपलोड",
  "aria/Flag Message": "संदेश फ्लैग करें",
  "aria/Image failed to load": "छवि लोड होने में विफल",
  "aria/Image input": "छवि इनपुट",
  "aria/Increase value": "मान बढ़ाएं",
  "aria/Jump to latest message": "नवीनतम संदेश पर जाएं",
  "aria/Jump to quoted message": "उद्धृत संदेश पर जाएं",
  "aria/Load More Channels": "और चैनल लोड करें",
  "aria/Mark Message Unread": "अपठित चिह्नित करें",
  "aria/Mark messages as read": "संदेशों को पढ़ा हुआ चिह्नित करें",
  "aria/Mention Suggestions": "उल्लेख सुझाव",
  "aria/Menu": "मेन्यू",
  "aria/Message Actions": "संदेश कार्रवाइयाँ",
  "aria/Message from {{ user }},": "{{ user }} का संदेश,",
  "aria/Message Options": "संदेश विकल्प",
  "aria/Message,": "संदेश,",
  "aria/Mute User": "उपयोगकर्ता म्यूट करें",
  "aria/Next page": "अगला पृष्ठ",
  "aria/Notifications": "सूचनाएं",
  "aria/Open Attachment Selector": "अटैचमेंट चयनकर्ता खोलें",
  "aria/Open Channel Actions Menu": "चैनल क्रियाएँ मेनू खोलें",
  "aria/Open channel details": "चैनल विवरण खोलें",
  "aria/Open image shared by {{ name }}": "{{ name }} द्वारा साझा की गई छवि खोलें",
  "aria/Open Menu": "मेन्यू खोलें",
  "aria/Open Message Actions Menu": "संदेश क्रिया मेन्यू खोलें",
  "aria/Open Reaction Selector": "प्रतिक्रिया चयनकर्ता खोलें",
  "aria/Open Thread": "थ्रेड खोलें",
  "aria/Open video shared by {{ name }}": "{{ name }} द्वारा साझा किया गया वीडियो खोलें",
  "aria/Pause": "रोकें",
  "aria/Pause recording": "रिकॉर्डिंग रोकें",
  "aria/Percent complete": "{{percent}} प्रतिशत पूर्ण",
  "aria/Pin Message": "संदेश पिन करें",
  "aria/Play": "चलाएँ",
  "aria/Previous page": "पिछला पृष्ठ",
  "aria/Quote Message": "संदेश उद्धरण",
  "aria/Reaction list": "प्रतिक्रिया सूची",
  "aria/Remind Me Message": "मुझे याद दिलाएं",
  "aria/Remind Me Options": "रिमाइंडर विकल्प",
  "aria/Remove attachment": "संलग्नक हटाएं",
  "aria/Remove location attachment": "स्थान संलग्नक हटाएं",
  "aria/Remove option": "विकल्प हटाएं",
  "aria/Remove Reminder": "अनुस्मारक हटाएं",
  "aria/Remove Save For Later": "बाद में देखें हटाएं",
  "aria/Resend Message": "संदेश फिर से भेजें",
  "aria/Resume recording": "रिकॉर्डिंग फिर शुरू करें",
  "aria/Retry upload": "अपलोड पुनः प्रयास करें",
  "aria/Review bounced message": "वापस लौटा संदेश समीक्षा करें",
  "aria/Search results": "खोज परिणाम",
  "aria/Search results header filter button for: {{ source }}": "{{ source }} के लिए खोज परिणाम शीर्षक फ़िल्टर बटन",
  "aria/Seek audio position": "ऑडियो स्थिति खोजें",
  "aria/Select Channel: {{ channelName }}": "चैनल चुनें: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "प्रतिक्रिया चुनें: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "उपयोगकर्ता चैनल चुनें: {{ name }}",
  "aria/Send": "भेजें",
  "aria/Show preview": "पूर्वावलोकन दिखाएं",
  "aria/Start recording audio": "ऑडियो रिकॉर्डिंग शुरू करें",
  "aria/Stop AI Generation": "एआई जनरेशन रोकें",
  "aria/Suggestions": "सुझाव",
  "aria/Thread list": "थ्रेड सूची",
  "aria/Unblock User": "उपयोगकर्ता अनब्लॉक करें",
  "aria/Unmute User": "उपयोगकर्ता अनम्यूट करें",
  "aria/Unpin Message": "संदेश अनपिन करें",
  "Ask a question": "एक प्रश्न पूछें",
  "Attach": "संलग्न करें",
  "Attach files": "फाइल्स अटैच करे",
  "Attachment": "अनुलग्नक",
  "Attachment upload blocked due to {{reason}}": "{{reason}} के कारण अटैचमेंट अपलोड ब्लॉक किया गया",
  "Attachment upload failed due to {{reason}}": "{{reason}} के कारण अटैचमेंट अपलोड विफल रहा",
  "Back": "वापस",
  "ban-command-args": "[@उपयोगकर्तनाम] [पाठ]",
  "ban-command-description": "एक उपयोगकर्ता को प्रतिषेधित करें",
  "Block user": "उपयोगकर्ता को ब्लॉक करें",
  "Block User": "उपयोगकर्ता को ब्लॉक करें",
  "Browse channel members": "चैनल सदस्य देखें",
  "Browse pinned messages": "पिन किए गए संदेश देखें",
  "Cancel": "रद्द करें",
  "Cannot seek in the recording": "रेकॉर्डिंग में खोज नहीं की जा सकती",
  "Changes saved": "बदलाव सहेजे गए",
  "Channel archived": "चैनल संग्रहीत किया गया",
  "Channel members": "चैनल सदस्य",
  "Channel Missing": "चैनल उपलब्ध नहीं है",
  "Channel muted": "चैनल म्यूट किया गया",
  "Channel pinned": "चैनल पिन किया गया",
  "Channel unarchived": "चैनल असंग्रहीत किया गया",
  "Channel unmuted": "चैनल अनम्यूट किया गया",
  "Channel unpinned": "चैनल अनपिन किया गया",
  "Channels": "चैनल",
  "Chat deleted": "Chat deleted",
  "Chats": "चैट",
  "Choose between 2 to 10 options": "2 से 10 विकल्प चुनें",
  "Close": "बंद करे",
  "Close dialog": "डायलॉग बंद करें",
  "Close emoji picker": "इमोजी पिकर बंद करें",
  "Close prompt: {{ title }}": "प्रॉम्प्ट बंद करें: {{ title }}",
  "Command not available while editing": "संपादन के दौरान कमांड उपलब्ध नहीं है",
  "Command not available while replying": "उत्तर देते समय कमांड उपलब्ध नहीं है",
  "Commands": "कमांड",
  "Commands matching": "मेल खाती है",
  "Connection failure, reconnecting now...": "कनेक्शन विफल रहा, अब पुनः कनेक्ट हो रहा है ...",
  "Contact info": "संपर्क जानकारी",
  "Contact name": "संपर्क का नाम",
  "Copy Message": "संदेश कॉपी करें",
  "Create": "बनाएँ",
  "Create a question, add options, and configure poll settings": "एक प्रश्न बनाएं, विकल्प जोड़ें और पोल सेटिंग्स कॉन्फ़िगर करें",
  "Create poll": "मतदान बनाएँ",
  "Current location": "वर्तमान स्थान",
  "Delete": "डिलीट",
  "Delete chat": "चैट हटाएं",
  "Delete for me": "मेरे लिए डिलीट करें",
  "Delete message": "संदेश हटाएं",
  "Delivered": "पहुंच गया",
  "Direct message": "प्रत्यक्ष संदेश",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "क्या आप अभी इस पोल को समाप्त करना चाहते हैं? इस पोल में अब कोई भी वोट नहीं कर पाएगा।",
  "Download All": "सब डाउनलोड करें",
  "Download Attachment": "अटैचमेंट डाउनलोड करें",
  "Download attachment {{ name }}": "अनुलग्नक {{ name }} डाउनलोड करें",
  "Drag your files here": "अपनी फ़ाइलें यहाँ खींचें",
  "Drag your files here to add to your post": "अपनी फ़ाइलें यहाँ खींचें और अपने पोस्ट में जोड़ने के लिए",
  "Due {{ timeLeft }}": "{{ timeLeft }} में देय",
  "Due since {{ dueSince }}": "{{ dueSince }} से देय",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit": "संपादित करें",
  "Edit chat data": "चैट डेटा संपादित करें",
  "Edit contact": "संपर्क संपादित करें",
  "Edit group": "समूह संपादित करें",
  "Edit Message": "मैसेज में बदलाव करे",
  "Edit message request failed": "संदेश संपादित करने का अनुरोध विफल रहा",
  "Edited": "संपादित",
  "Emoji matching": "इमोजी मिलान",
  "Empty message...": "खाली संदेश ...",
  "End": "समाप्त",
  "End poll": "पोल समाप्त करें",
  "End this poll?": "इस पोल को समाप्त करें?",
  "End vote": "मत समाप्त करें",
  "Enforce unique vote is enabled": "अनोखा वोट सक्षम है",
  "Error": "त्रुटि",
  "Error adding flag": "ध्वज जोड़ने में त्रुटि",
  "Error adding members": "Error adding members",
  "Error blocking user": "उपयोगकर्ता को ब्लॉक करने में त्रुटि",
  "Error connecting to chat, refresh the page to try again.": "चैट से कनेक्ट करने में त्रुटि, पेज को रिफ्रेश करें",
  "Error deleting chat": "Error deleting chat",
  "Error deleting message": "संदेश हटाने में त्रुटि",
  "Error fetching reactions": "प्रतिक्रियाएँ लोड करने में त्रुटि",
  "Error marking message unread": "संदेश को अपठित चिह्नित करने में त्रुटि",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "संदेश को अपठित मार्क करने में त्रुटि। सबसे नए 100 चैनल संदेश से पहले के सभी अपठित संदेशों को अपठित मार्क नहीं किया जा सकता है।",
  "Error muting a user ...": "यूजर को म्यूट करने का प्रयास फेल हुआ",
  "Error muting channel": "चैनल म्यूट करने में त्रुटि",
  "Error muting user": "उपयोगकर्ता को म्यूट करने में त्रुटि",
  "Error opening direct message": "सीधा संदेश खोलने में त्रुटि",
  "Error pinning message": "संदेश को पिन करने में त्रुटि",
  "Error removing members": "सदस्यों को हटाने में त्रुटि",
  "Error removing message pin": "संदेश पिन निकालने में त्रुटि",
  "Error removing user": "उपयोगकर्ता हटाने में त्रुटि",
  "Error reproducing the recording": "रिकॉर्डिंग पुन: उत्पन्न करने में त्रुटि",
  "Error starting recording": "रेकॉर्डिंग शुरू करने में त्रुटि",
  "Error unblocking user": "उपयोगकर्ता को अनब्लॉक करने में त्रुटि",
  "Error unmuting a user ...": "यूजर को अनम्यूट करने का प्रयास फेल हुआ",
  "Error unmuting channel": "चैनल को अनम्यूट करने में त्रुटि",
  "Error unmuting user": "उपयोगकर्ता को अनम्यूट करने में त्रुटि",
  "Error uploading attachment": "अटैचमेंट अपलोड करते समय त्रुटि",
  "Error uploading file": "फ़ाइल अपलोड करने में त्रुटि",
  "Error uploading image": "छवि अपलोड करने में त्रुटि",
  "Error: {{ errorMessage }}": "फेल: {{ errorMessage }}",
  "Exit command {{ command }}": "कमांड से बाहर निकलें {{ command }}",
  "Failed to block user": "उपयोगकर्ता को ब्लॉक करने में विफल",
  "Failed to create the poll": "मतदान बनाने में विफल",
  "Failed to create the poll due to {{reason}}": "मतदान {{reason}} के कारण नहीं बन सका",
  "Failed to delete the message": "संदेश हटाने में विफल",
  "Failed to end the poll": "पोल समाप्त करने में विफल",
  "Failed to end the poll due to {{reason}}": "{{reason}} के कारण पोल समाप्त करने में विफल",
  "Failed to jump to the first unread message": "पहले अपठित संदेश पर जाने में विफल",
  "Failed to leave channel": "चैनल छोड़ने में विफल",
  "Failed to load channels": "चैनल लोड करने में विफल",
  "Failed to load more channels": "और चैनल लोड करने में विफल",
  "Failed to mark channel as read": "चैनल को पढ़ा हुआ चिह्नित करने में विफल।",
  "Failed to play the recording": "रेकॉर्डिंग प्ले करने में विफल",
  "Failed to retrieve location": "स्थान प्राप्त करने में विफल",
  "Failed to save changes": "बदलाव सहेजने में विफल",
  "Failed to share location": "स्थान साझा करने में विफल",
  "Failed to update channel archive status": "चैनल के आर्काइव स्थिति को अपडेट करने में विफल",
  "Failed to update channel mute status": "चैनल की म्यूट स्थिति को अपडेट करने में विफल",
  "Failed to update channel pinned status": "चैनल की पिन स्थिति को अपडेट करने में विफल",
  "File": "फ़ाइल",
  "File is required for upload attachment": "अटैचमेंट अपलोड के लिए फ़ाइल आवश्यक है",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "फ़ाइल बहुत बड़ी है: {{ size }}, अधिकतम अपलोड साइज़ {{ limit }} है",
  "File too large": "फ़ाइल बहुत बड़ी है",
  "fileCount_one": "1 फ़ाइल",
  "fileCount_other": "{{ count }} फ़ाइलें",
  "Files": "फ़ाइलें",
  "Flag": "फ्लैग करे",
  "Generating...": "बना रहा है...",
  "giphy-command-args": "[पाठ]",
  "giphy-command-description": "चैनल पर एक क्रॉफिल जीआइएफ पोस्ट करें",
  "Go back": "वापस जाएं",
  "Group info": "समूह जानकारी",
  "Group name": "समूह का नाम",
  "Hide who voted": "किसने वोट दिया छिपाएं",
  "Image": "छवि",
  "imageCount_one": "1 छवि",
  "imageCount_other": "{{ count }} छवियाँ",
  "Instant commands": "तत्काल कमांड",
  "language/af": "अफ्रीकी",
  "language/am": "अम्हारिक",
  "language/ar": "अरबी",
  "language/az": "अज़रबैजानी",
  "language/bg": "बुल्गारियाई",
  "language/bn": "बंगाली",
  "language/bs": "बोस्नियाई",
  "language/cs": "चेक",
  "language/da": "डेनिश",
  "language/de": "जर्मन",
  "language/el": "यूनानी",
  "language/en": "अंग्रेज़ी",
  "language/es": "स्पेनिश",
  "language/es-MX": "स्पेनिश (मेक्सिको)",
  "language/et": "एस्तोनियाई",
  "language/fa": "फ़ारसी",
  "language/fa-AF": "दरी",
  "language/fi": "फ़िनिश",
  "language/fr": "फ़्रेंच",
  "language/fr-CA": "फ़्रेंच (कनाडा)",
  "language/ha": "हौसा",
  "language/he": "हिब्रू",
  "language/hi": "हिंदी",
  "language/hr": "क्रोएशियाई",
  "language/ht": "हैतियाई क्रियोल",
  "language/hu": "हंगेरी",
  "language/id": "इंडोनेशियाई",
  "language/it": "इतालवी",
  "language/ja": "जापानी",
  "language/ka": "जॉर्जियाई",
  "language/ko": "कोरियाई",
  "language/lt": "लिथुआनियाई",
  "language/lv": "लातवियाई",
  "language/ms": "मलय",
  "language/nl": "डच",
  "language/no": "नॉर्वेजियाई",
  "language/pl": "पोलिश",
  "language/ps": "पश्तो",
  "language/pt": "पुर्तगाली",
  "language/ro": "रोमानियाई",
  "language/ru": "रूसी",
  "language/sk": "स्लोवाक",
  "language/sl": "स्लोवेनियाई",
  "language/so": "सोमाली",
  "language/sq": "अल्बानियाई",
  "language/sr": "सर्बियाई",
  "language/sv": "स्वीडिश",
  "language/sw": "स्वाहिली",
  "language/ta": "तमिल",
  "language/th": "थाई",
  "language/tl": "तागालोग",
  "language/tr": "तुर्की",
  "language/uk": "यूक्रेनियाई",
  "language/ur": "उर्दू",
  "language/vi": "वियतनामी",
  "language/zh": "चीनी (सरलीकृत)",
  "language/zh-TW": "चीनी (पारंपरिक)",
  "Last seen {{ timestamp }}": "अंतिम बार {{ timestamp }} देखा गया",
  "Leave Channel": "चैनल छोड़ें",
  "Leave chat": "चैनल छोड़ें",
  "Left channel": "चैनल छोड़ दिया गया",
  "Let others add options": "दूसरों को विकल्प जोड़ने दें",
  "Limit votes per person": "प्रति व्यक्ति वोट सीमित करें",
  "Link": "लिंक",
  "linkCount_one": "1 लिंक",
  "linkCount_other": "{{ count }} लिंक",
  "live": "लाइव",
  "Live for {{duration}}": "{{duration}} के लिए लाइव",
  "Live location": "लाइव स्थान",
  "Live until {{ timestamp }}": "{{ timestamp }} तक लाइव",
  "Load more": "और लोड करें",
  "Local upload attachment missing local id": "लोकल अपलोड अटैचमेंट में लोकल आईडी नहीं है",
  "Location": "स्थान",
  "Location sharing ended": "स्थान साझा करना समाप्त",
  "Location: {{ coordinates }}": "स्थान: {{ coordinates }}",
  "Manage channel": "चैनल प्रबंधित करें",
  "Manage members": "सदस्य प्रबंधित करें",
  "Mark as unread": "अपठित चिह्नित करें",
  "Maximum number of votes (from 2 to 10)": "अधिकतम वोटों की संख्या (2 से 10)",
  "Maximum votes per person": "प्रति व्यक्ति अधिकतम वोट",
  "Member detail": "सदस्य विवरण",
  "mention/Channel": "चैनल",
  "mention/Channel Description": "इस चैनल में सभी को सूचित करें",
  "mention/Here": "यहां",
  "mention/Here Description": "इस चैनल के सभी ऑनलाइन सदस्यों को सूचित करें",
  "Menu": "मेन्यू",
  "Message deleted": "मैसेज हटा दिया गया",
  "Message failed to send": "संदेश भेजने में विफल",
  "Message has been successfully flagged": "मैसेज को फ्लैग कर दिया गया है",
  "Message marked as unread": "संदेश को अपठित के रूप में चिह्नित किया गया",
  "Message pinned": "संदेश पिन किया गया",
  "Message unpinned": "संदेश अनपिन किया गया",
  "Message was blocked by moderation policies": "संदेश को मॉडरेशन नीतियों द्वारा ब्लॉक कर दिया गया है",
  "Messages have been marked unread.": "संदेशों को अपठित चिह्नित किया गया है।",
  "Missing permissions to upload the attachment": "अटैचमेंट अपलोड करने के लिए अनुमतियां गायब",
  "Moderator": "मॉडरेटर",
  "Multiple votes": "कई वोट",
  "Mute": "म्यूट करे",
  "Mute chat": "चैट म्यूट करें",
  "Mute user": "उपयोगकर्ता को म्यूट करें",
  "mute-command-args": "[@उपयोगकर्तनाम]",
  "mute-command-description": "एक उपयोगकर्ता को म्यूट करें",
  "network error": "नेटवर्क त्रुटि",
  "New": "नए",
  "New message from {{user}}": "{{user}} से नया संदेश",
  "New Messages!": "नए मैसेज!",
  "Next": "अगला",
  "Next image": "अगली छवि",
  "No chats here yet…": "यहां अभी तक कोई चैट नहीं...",
  "No conversations yet": "अभी तक कोई बातचीत नहीं है",
  "No files": "कोई फ़ाइल नहीं",
  "No items exist": "कोई आइटम मौजूद नहीं है",
  "No member found": "कोई सदस्य नहीं मिला",
  "No messages found": "कोई संदेश नहीं मिला",
  "No photos or videos": "कोई फ़ोटो या वीडियो नहीं",
  "No pinned messages": "कोई पिन किया गया संदेश नहीं",
  "No results found": "कोई परिणाम नहीं मिला",
  "No user found": "कोई उपयोगकर्ता नहीं मिला",
  "Nobody will be able to vote in this poll anymore.": "अब कोई भी इस मतदान में मतदान नहीं कर सकेगा।",
  "Nothing yet...": "कोई मैसेज नहीं है",
  "Notify all {{ role }} members": "{{ role }} भूमिका वाले सभी सदस्यों को सूचित करें",
  "Offline": "ऑफलाइन",
  "Ok": "ठीक है",
  "Online": "ऑनलाइन",
  "Only numbers are allowed": "केवल संख्याएँ अनुमत हैं",
  "Only visible to you": "केवल आपको दिखाई देता है",
  "Open emoji picker": "इमोजी पिकर खोलिये",
  "Open gallery at image {{ index }}": "गैलरी को छवि {{ index }} पर खोलें",
  "Open image in gallery": "छवि को गैलरी में खोलें",
  "Open location in a map": "मानचित्र में स्थान खोलें",
  "Open members actions": "Open members actions",
  "Open menu": "मेन्यू खोलें",
  "Option already exists": "विकल्प पहले से मौजूद है",
  "Option is empty": "विकल्प खाली है",
  "Options": "विकल्प",
  "Original": "मूल",
  "Owner": "मालिक",
  "People matching": "मेल खाते लोग",
  "Photo": "फ़ोटो",
  "Photos & videos": "फ़ोटो और वीडियो",
  "Pin": "पिन",
  "Pin a message to see it here": "इसे यहाँ देखने के लिए संदेश पिन करें",
  "Pinned by {{ name }}": "{{ name }} द्वारा पिन किया गया",
  "Pinned by You": "आपके द्वारा पिन किया गया",
  "Pinned message": "पिन किया गया संदेश",
  "Pinned messages": "पिन किए गए संदेश",
  "placeholder/PollComment": "आपकी टिप्पणी",
  "placeholder/PollOptionSuggestion": "नया विकल्प दर्ज करें",
  "Play video": "वीडियो चलाएं",
  "Playback speed {{ rate }}x": "प्लेबैक गति {{ rate }}x",
  "Poll": "मतदान",
  "Poll comments": "मतदान टिप्पणियाँ",
  "Poll ended": "पोल समाप्त",
  "Poll options": "मतदान विकल्प",
  "Poll results": "मतदान परिणाम",
  "Previous": "पिछला",
  "Previous image": "पिछली छवि",
  "Question": "प्रश्न",
  "Question {{ optionOrderNumber}}": "प्रश्न {{ optionOrderNumber}}",
  "Question is required": "प्रश्न आवश्यक है",
  "Quote Reply": "उद्धरण जवाब",
  "Reached the vote limit. Remove an existing vote first.": "मतदान सीमा तक पहुंच गया। पहले एक मौजूदा वोट हटाएं।",
  "Recording format is not supported and cannot be reproduced": "रेकॉर्डिंग फ़ॉर्मेट समर्थित नहीं है और पुनः उत्पन्न नहीं किया जा सकता",
  "Remind me": "मुझे याद दिलाएं",
  "Remind Me": "मुझे याद दिलाएं",
  "Reminder set": "अनुस्मारक सेट किया गया",
  "Remove": "हटाएं",
  "Remove {{ count }} members_one": "{{ count }} सदस्य हटाएं",
  "Remove {{ count }} members_other": "{{ count }} सदस्य हटाएं",
  "Remove {{ member }} from this channel?": "इस चैनल से {{ member }} को हटाएं?",
  "Remove channel members": "चैनल सदस्य हटाएं",
  "Remove reminder": "रिमाइंडर हटाएं",
  "Remove save for later": "बाद में देखें हटाएं",
  "Remove user": "उपयोगकर्ता हटाएं",
  "Removed {{ count }} members_one": "{{ count }} सदस्य हटाया गया",
  "Removed {{ count }} members_other": "{{ count }} सदस्य हटाए गए",
  "Replied to a thread": "थ्रेड में जवाब दिया",
  "Reply": "जवाब दे दो",
  "Reply to {{ authorName }}": "{{ authorName }} को जवाब दें",
  "Reply to a message to start a thread": "थ्रेड शुरू करने के लिए किसी संदेश का जवाब दें",
  "Reply to Message": "संदेश का जवाब दें",
  "replyCount_one": "1 रिप्लाई",
  "replyCount_other": "{{ count }} रिप्लाई",
  "Resend": "फिर से भेजें",
  "Retry upload": "अपलोड फिर से करें",
  "Review all options available in this poll": "इस पोल में उपलब्ध सभी विकल्पों की समीक्षा करें",
  "Review comments submitted with poll answers": "पोल उत्तरों के साथ भेजी गई टिप्पणियों की समीक्षा करें",
  "Review poll results and open an option to see detailed votes": "पोल परिणामों की समीक्षा करें और विस्तृत वोट देखने के लिए एक विकल्प खोलें",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "इस संदेश की समीक्षा करें और चुनें कि इसे हटाना है, संपादित करना है या फिर भी भेजना है",
  "Review who voted for this option": "समीक्षा करें कि इस विकल्प के लिए किसने वोट किया",
  "Save": "सहेजें",
  "Save for later": "बाद के लिए सहेजें",
  "Saved for later": "बाद के लिए सहेजा गया",
  "Search": "खोज",
  "Search GIFs": "GIF खोजें",
  "search-results-header-filter-source-button-label--channels": "चैनल्स",
  "search-results-header-filter-source-button-label--messages": "संदेश",
  "search-results-header-filter-source-button-label--users": "उपयोगकर्ता",
  "Searching for {{ searchSourceType }}...": "{{ searchSourceType }} खोज रहे हैं...",
  "Searching...": "खोज कर...",
  "searchResultsCount_one": "1 परिणाम",
  "searchResultsCount_other": "{{ count }} परिणाम",
  "Select a thread to continue the conversation": "बातचीत जारी रखने के लिए एक थ्रेड चुनें",
  "Select more than one option": "एक से अधिक विकल्प चुनें",
  "Select one": "एक चुनें",
  "Select one or more": "एक या अधिक चुनें",
  "Select up to {{count}}_one": "अधिकतम {{count}} तक चुनें",
  "Select up to {{count}}_other": "अधिकतम {{count}} तक चुनें",
  "Select your current location and optionally enable live location sharing": "अपना वर्तमान स्थान चुनें और वैकल्पिक रूप से लाइव लोकेशन शेयरिंग सक्षम करें",
  "Send": "भेजे",
  "Send a message": "संदेश भेजें",
  "Send a message to start the conversation": "बातचीत शुरू करने के लिए संदेश भेजें",
  "Send Anyway": "वैसे भी भेजें",
  "Send direct message": "सीधा संदेश भेजें",
  "Send message request failed": "संदेश भेजने का अनुरोध विफल रहा",
  "Send poll": "पोल भेजें",
  "Sending...": "भेजा जा रहा है",
  "Sent": "भेजा गया",
  "Share": "साझा करें",
  "Share a file to see it here": "इसे यहाँ देखने के लिए एक फ़ाइल साझा करें",
  "Share a photo or video to see it here": "इसे यहाँ देखने के लिए एक फ़ोटो या वीडियो साझा करें",
  "Share live location for": "लाइव स्थान साझा करें",
  "Share Location": "स्थान साझा करें",
  "Shared live location": "साझा किया गया लाइव स्थान",
  "Shared location": "साझा स्थान",
  "Shuffle": "मिश्रित करें",
  "size limit": "आकार सीमा",
  "Slow Mode ON": "स्लो मोड ऑन",
  "Slow mode, wait {{ seconds }}s...": "स्लो मोड, {{ seconds }} सेकंड प्रतीक्षा करें...",
  "Some of the files will not be accepted": "कुछ फ़ाइलें स्वीकार नहीं की जाएंगी",
  "Start typing to search": "खोजने के लिए टाइप करना शुरू करें",
  "Stop sharing": "साझा करना बंद करें",
  "Submit": "जमा करें",
  "Suggest a new option to add to this poll": "इस पोल में जोड़ने के लिए एक नया विकल्प सुझाएं",
  "Suggest an option": "एक विकल्प सुझाव दें",
  "Tap to remove": "हटाने के लिए टैप करें",
  "Tap to remove: {{ reactionName }}": "हटाने के लिए टैप करें: {{ reactionName }}",
  "Thinking...": "सोच रहा है...",
  "this content could not be displayed": "यह कॉन्टेंट लोड नहीं हो पाया",
  "This field cannot be empty or contain only spaces": "यह फ़ील्ड खाली नहीं हो सकता या केवल रिक्त स्थान नहीं रख सकता",
  "This message did not meet our content guidelines": "यह संदेश हमारे सामग्री दिशानिर्देशों के अनुरूप नहीं था",
  "This permanently deletes your message history with {{ user }}. This can't be undone.": "This permanently deletes your message history with {{ user }}. This can't be undone.",
  "This user will be able to message you again.": "यह उपयोगकर्ता आपको फिर से संदेश भेज सकेगा।",
  "This user won't be able to message you anymore. You can unblock them anytime.": "This user won't be able to message you anymore. You can unblock them anytime.",
  "Thread": "रिप्लाई थ्रेड",
  "Thread has not been found": "थ्रेड नहीं मिला",
  "Thread reply": "थ्रेड में उत्तर",
  "Thread Reply": "थ्रेड में उत्तर",
  "ThreadListUnseenThreadsBanner/loading": "लोड हो रहा है...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} अपठित थ्रेड",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} अपठित थ्रेड",
  "Threads": "थ्रेड्स",
  "timestamp/ChannelDetailPinnedMessageTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Yesterday]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/ChannelMembersLastActive": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[बीता कल]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[आज]\", \"nextDay\": \"[कल]\", \"lastDay\": \"[बीता कल]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[पिछला] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }} दिन पहले",
  "timestamp/relativeToday": "आज",
  "timestamp/relativeWeeksAgo": "{{ count }} सप्ताह पहले",
  "timestamp/relativeYesterday": "बीता कल",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[आज] HH:mm\", \"nextDay\": \"[कल] HH:mm\", \"lastDay\": \"[बीता कल] HH:mm\", \"nextWeek\": \"dddd HH:mm\", \"lastWeek\": \"[पिछले] dddd, HH:mm\", \"sameElse\": \"ddd, D MMM HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "रिकॉर्डिंग शुरू करने के लिए, अपने ब्राउज़र में कैमरा तक पहुँच दें",
  "To start recording, allow the microphone access in your browser": "रिकॉर्डिंग शुरू करने के लिए, अपने ब्राउज़र में माइक्रोफ़ोन तक पहुँच दें",
  "totalVoteCount_one": "कुल 1 वोट",
  "totalVoteCount_other": "कुल {{ count }} वोट",
  "Translated": "अनुवादित",
  "Translated from {{ language }}": "{{ language }} से अनुवादित",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "2 से 10 तक का एक नंबर टाइप करें",
  "Unarchive": "अनआर्काइव",
  "unban-command-args": "[@उपयोगकर्तनाम]",
  "unban-command-description": "एक उपयोगकर्ता को प्रतिषेध से मुक्त करें",
  "Unblock": "अनब्लॉक करें",
  "Unblock user": "उपयोगकर्ता अनब्लॉक करें",
  "Unblock User": "उपयोगकर्ता अनब्लॉक करें",
  "unknown error": "अज्ञात त्रुटि",
  "Unmute": "अनम्यूट",
  "Unmute chat": "चैट अनम्यूट करें",
  "Unmute user": "उपयोगकर्ता को अनम्यूट करें",
  "unmute-command-args": "[@उपयोगकर्तनाम]",
  "unmute-command-description": "एक उपयोगकर्ता को अनम्यूट करें",
  "Unpin": "अनपिन",
  "Unread messages": "अपठित संदेश",
  "Unsupported attachment": "असमर्थित अटैचमेंट",
  "unsupported file type": "असमर्थित फ़ाइल प्रकार",
  "Update": "अपडेट करें",
  "Update the comment attached to your poll answer": "अपने पोल उत्तर से जुड़ी टिप्पणी अपडेट करें",
  "Update your comment": "अपने टिप्पणी को अपडेट करें",
  "Upload blocked": "अपलोड अवरुद्ध",
  "Upload error": "अपलोड त्रुटि",
  "Upload failed": "अपलोड विफल",
  "Upload Picture": "चित्र अपलोड करें",
  "Upload type: \"{{ type }}\" is not allowed": "अपलोड प्रकार: \"{{ type }}\" की अनुमति नहीं है",
  "User blocked": "उपयोगकर्ता अवरुद्ध किया गया",
  "User muted": "उपयोगकर्ता म्यूट किया गया",
  "User removed": "उपयोगकर्ता हटा दिया गया",
  "User unblocked": "उपयोगकर्ता अनब्लॉक किया गया",
  "User unmuted": "उपयोगकर्ता अनम्यूट किया गया",
  "User uploaded content": "उपयोगकर्ता अपलोड की गई सामग्री",
  "Video": "वीडियो",
  "videoCount_one": "1 वीडियो",
  "videoCount_other": "{{ count }} वीडियो",
  "View": "देखें",
  "View {{count}} comments_one": "देखें {{count}} टिप्पणी",
  "View {{count}} comments_other": "देखें {{count}} टिप्पणियाँ",
  "View all": "सभी देखें",
  "View member details for {{ member }}": "{{ member }} के सदस्य विवरण देखें",
  "View original": "मूल देखें",
  "View results": "परिणाम देखें",
  "View translation": "अनुवाद देखें",
  "Voice message": "आवाज संदेश",
  "Voice message {{ duration }}": "वॉइस संदेश {{ duration }}",
  "Voice message deleted": "वॉइस संदेश हटा दिया गया",
  "voiceMessageCount_one": "1 ध्वनि संदेश",
  "voiceMessageCount_other": "{{ count }} ध्वनि संदेश",
  "Vote ended": "मतदान समाप्त",
  "Votes": "वोट",
  "Wait until all attachments have uploaded": "सभी अटैचमेंट अपलोड होने तक प्रतीक्षा करें",
  "Waiting for network…": "नेटवर्क की प्रतीक्षा…",
  "You": "आप",
  "You've reached the maximum number of files": "आप अधिकतम फ़ाइलों तक पहुँच गए हैं"
}
